module.exports = __webpack_public_path__ + "static/media/mbl_featured.716c5aba.svg";